export const ids = {
  automaticDataCollection: "automatic-data-collection" as const,
  avatarTestimonialsCarousel: "testimonials" as const,
  journeySchedule: "journey-schedule" as const,
  laurenOrigin: "lauren-origin" as const,
  meetCoaches: "meet-the-coaches" as const,
  newsletter: "newsletter" as const,
  onlineTrackingOptOut: "online-tracking-opt-out" as const,
  pricingTable: "pricing-table" as const,
  refundFaq: "refund-faq" as const,
  scholarshipFaq: "scholarship-faq" as const,
  shareYours: "share-yours" as const,
  startJourney: "start-journey" as const,
  videoLauren: "video-lauren" as const,
};
